import { createSelector } from 'reselect'
import { emptyArr } from 'util/arrays'
import { emptyObj } from 'util/objects'
import { selectBase } from './base'

export const selectWidgetKbCatalog = createSelector(
  selectBase,
  base => base.kbCatalog || emptyObj
)

export const selectWidgetKnowledgeBases = createSelector(
  selectWidgetKbCatalog,
  catalog => catalog.knowledgeBases || emptyArr
)

export const selectWidgetKnowledgeBasesForDropdown = createSelector(
  selectWidgetKnowledgeBases,
  kbs =>
    kbs
      .slice()
      .sort((a, b) =>
        String(a.title || '').localeCompare(String(b.title || ''))
      )
      .map(kb => ({
        key: kb.id,
        text: kb.title,
        value: kb.id,
      }))
)

export const selectWidgetPrimaryKnowledgeBase = createSelector(
  selectWidgetKnowledgeBases,
  kbs => kbs.find(kb => kb.primary)
)

export const selectIsWidgetKbCatalogLoading = createSelector(
  selectWidgetKbCatalog,
  catalog => !!catalog.isLoading
)

export const selectIsWidgetKbCatalogLoaded = createSelector(
  selectWidgetKbCatalog,
  catalog => !!catalog.loaded
)

export const selectWidgetKbCatalogError = createSelector(
  selectWidgetKbCatalog,
  catalog => catalog.error
)
